<template>
  <div class="legends">
    <div class="legends__box">
      <header class="legends__box__header">
        <ui-button
          class="legends__box__header__close"
          @click.prevent="toggleLegends(false)"
          button="secondary"
          :label="$t('commons.buttons.close')"
          :icon-only="true"
          icon="close"
        />
        <div class="legends__box__header__title">
          {{ $t('legends.title') }}
        </div>
      </header>
      <div class="legends__box__content">
        <div class="legends__box__content__legend" v-for="(legend, index) in legends" :key="`legend ${index}`">
          {{ legend.label }} ({{ numberFormat({ number: legend.amount, style: 'currency', currency: 'USD' }) }})
        </div>
        <div class="legends__box__content__legend legends__box__content__legend--total">
          {{ $t('legends.all') }} {{ numberFormat({ number: totalSourcesAmount, style: 'currency', currency: 'USD' }) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { numberFormat } from '@/utils/formatters.util'

import UiButton from '@/components/UI/Button.vue'

export default {
  props: {
    legends: {
      type: Array,
      required: true,
    },
  },
  components: {
    UiButton,
  },
  data() {
    return {
      numberFormat,
    }
  },
  computed: {
    ...mapGetters({
      sourcesAmount: 'data/sourcesAmount',
      totalSourcesAmount: 'algolia/totalSourcesAmount',
    }),
  },
  methods: {
    ...mapActions({
      toggleLegends: 'radar/toggleLegends',
    }),
  },
}
</script>

<style lang="scss" scoped>
.legends {
  @include wrapper(flex-end, $gutter-md, 1);
  pointer-events: none;
  bottom: auto;
  @media (min-width: $screen-sm) {
    left: initial;
    bottom: 92px;
  }
  &__box {
    @include box(2, rgba(255, 255, 255, 0.9));
    pointer-events: all;
    padding: $gutter-sm 0px $gutter-sm $gutter-sm;
    width: 100%;
    box-shadow: $generic-box-shadow;
    @media (min-width: $screen-sm) {
      width: $gmap-sidebar-width-tablet;
    }
    &__header {
      position: relative;
      &__close {
        @include close;
        background-color: inherit;
        border: none;
        color: $red-orange;
      }
      &__title {
        font-size: $font-size-default;
        font-weight: $font-weight-title;
      }
    }
    &__content {
      margin: $gutter-sm 0;
      &__legend {
        margin: 4px 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: $font-size-sm;

        &--total {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
